import { inject } from '@angular/core';
import { DetailAgendapunt2Component } from './detail-agendapunt/detail-agendapunt.component';
import { AgendapuntService, IAgendapuntViewResult } from './agendapunt.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes, ResolveFn } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BoaActivityComponent } from './boa-activity/boa-activity.component';

const agendapuntResolver: ResolveFn<any> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : IAgendapuntViewResult | Observable<IAgendapuntViewResult> | Promise<IAgendapuntViewResult> => {
    const agendapuntService = inject(AgendapuntService);
    const id = +route.paramMap.get('id');
    const zittingId = +route.paramMap.get('zittingid');
    const besprekenActive = route.paramMap.get('bespreken') === 'true';
    const agendapunt$ = agendapuntService.getDetailAgendapunt(zittingId, id);
    const agendapuntIds$ = agendapuntService.getAgendapuntIds(zittingId, besprekenActive); // state2.getSubValueOrDefault('agendapuntids',bespreken ? -zittingId : zittingId,this.agendapuntService.getAgendapuntIds(zittingId,bespreken));
    return forkJoin([agendapunt$, agendapuntIds$, of(besprekenActive)]).pipe(
      map(([agendapunt, agendapuntIds, bespreken]) => ({ agendapunt, agendapuntIds, bespreken }) as IAgendapuntViewResult)
    );
  }

export const agendapuntRoutes : Routes = [
  { 
    path: 'agendapunt', providers:[AgendapuntService],
    children:[
      { path: ':zittingid/:id/:bespreken', component: DetailAgendapunt2Component, resolve: { viewData: agendapuntResolver } /*, runGuardsAndResolvers: 'always'*/ },
      { path: ':zittingid/:id/:bespreken/:docid', component: DetailAgendapunt2Component, resolve: { viewData: agendapuntResolver } /*, runGuardsAndResolvers: 'always'*/ },
      { path: 'boadetail/:id', component: BoaActivityComponent }
    ]
  }
];
